var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 40,
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mobile_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.273 0H4.728C2.12 0 0 2.11 0 4.706v30.588C0 37.89 2.12 40 4.728 40h16.545c2.606 0 4.728-2.11 4.728-4.706V4.706C26 2.111 23.879 0 21.273 0m-4.276 2.353-1.181 2.353h-5.63L9.002 2.353zm-12.27 0h1.634L8.725 7.06h8.552l2.364-4.706h1.633a2.36 2.36 0 0 1 2.364 2.353v25.882H2.364V4.706a2.36 2.36 0 0 1 2.364-2.353m16.546 35.294H4.728a2.36 2.36 0 0 1-2.364-2.353V32.94h21.273v2.353a2.36 2.36 0 0 1-2.364 2.353"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.819 20h2.364a1.18 1.18 0 0 1 1.181 1.177c0 .649-.53 1.176-1.181 1.176H9.455v2.353h2.364v2.353h2.364v-2.353c1.954 0 3.545-1.583 3.545-3.53 0-1.945-1.59-3.53-3.545-3.53h-2.364a1.18 1.18 0 0 1-1.182-1.176c0-.648.53-1.176 1.182-1.176h4.727V12.94h-2.363v-2.354h-2.364v2.354c-1.955 0-3.546 1.583-3.546 3.53 0 1.945 1.59 3.529 3.546 3.529"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h26v40H0z"
})))));
export default SvgMobile;